import { QueryKeys } from "@/constants/queryKeys";
import { queryOptions, useQuery } from "@tanstack/react-query";

import useSession from "@/hooks/QueryHooks/useSession";
import { getUserUnviewedNotificationsAction } from "../actions";

export const USER_UNVIEWED_NOTIFICATIONS_QUERY_KEYS = {
  all: [QueryKeys.NOTIFICATIONS],
  getUserUnviewedNotifications: () => [
    ...USER_UNVIEWED_NOTIFICATIONS_QUERY_KEYS.all,
    "get-user-unviewed-notifications",
  ],
};

export function getUserUnviewedNotificationsQueryOptions({
  userId,
  emailVerified,
}: {
  userId: string;
  emailVerified?: boolean;
}) {
  return queryOptions({
    queryKey:
      USER_UNVIEWED_NOTIFICATIONS_QUERY_KEYS.getUserUnviewedNotifications(),
    queryFn: getUserUnviewedNotificationsAction,
    enabled: !!userId && !!emailVerified,
  });
}

export const useUserUnviewedNotifications = () => {
  const { data: session } = useSession();
  return useQuery(
    getUserUnviewedNotificationsQueryOptions({
      userId: session?.id,
      emailVerified: !!session?.emailVerified,
    }),
  );
};
